import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function TumourDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Tumour Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Type of Tumour:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.typeOfTumour.referToAttachments}>
                        <p>{questions.typeOfTumour.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>
                
                <QuestionWrapper number='2'>
                    <Question>Was it localised to the tissue or organ of origin?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.localisedToOrigin.referToAttachments}>
                        <p>{questions.localisedToOrigin.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Exact Staging/histology:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.exactStaging.referToAttachments}>
                        <p>{questions.exactStaging.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Size of tumour:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.sizeOfTumour.referToAttachments}>
                        <p>{questions.sizeOfTumour.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Were any lymph nodes involved?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyLymphNodesInvolved.referToAttachments}>
                        <p>{questions.anyLymphNodesInvolved.value}</p>
                        {questions.anyLymphNodesInvolved.value === 'Yes' && (
                            <>
                                <Question>If yes, confirm how many:</Question>
                                <p>{questions.anyLymphNodesInvolved.numLymphNodes}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Were there any metastases?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyMetastases.referToAttachments}>
                        <p>{questions.anyMetastases.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Please confirm if the customer had Neoadjuvant Chemotherapy? </Question>
                    <ReferrableQuestionWrapper isReferred={questions.receivedNeoadjuvantChemotherapy.referToAttachments}>
                        <p>{questions.receivedNeoadjuvantChemotherapy.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Details of all Treatment:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.detailsOfTreatment.referToAttachments}>
                        <p>{questions.detailsOfTreatment.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='9'>
                    <Question>Is Treatment Complete:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.isTreatmentComplete.referToAttachments}>
                        <p>{questions.isTreatmentComplete.value}</p>
                        {questions.isTreatmentComplete.value === 'Yes' && (
                            <>
                                <Question>If yes, please confirm the date treatment finished:</Question>
                                <p>{formatDateMonthYear(questions.dateTreatmentFinished.value)}</p>
                            </>
                        )}
                        {questions.isTreatmentComplete.value === 'No' && (
                            <>
                                <Question>If no, please provide details of ongoing treatment:</Question>
                                <p>{questions.detailsOfOngoingTreatment.value}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>
                
                <QuestionWrapper number='10'>
                    <Question>Completely eradicated/no recurrence</Question>
                    <ReferrableQuestionWrapper isReferred={questions.completelyEradicated.referToAttachments}>
                        <p>{questions.completelyEradicated.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}